import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);
export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: "#5568F1",
				primary2: "4E78F4",
				accent: "#FF5555",
				grey: "#7b7b93",
				lightGrey: "#E4E4E4",
				offWhite: "#FAFAFD", 
				lilac: "#DBDBFC",
				yellow: "#ffbd08"
			},
			dark: {
				primary: colors.blue.lighten3,
			},
		},
	},
})
